<template>
    <div class="contens" >
        <!-- 头部表单 -->
        <div class="contens_header">
            <div class="contens_header_span">
                <span>积分总用户数:</span>
                <span class="contens_header_span_number">{{integralNumbers}}</span>
            </div>
             <div class="contens_header_span">
                <span>可兑换优惠券数:</span>
                <span class="contens_header_span_number">{{integralquanNum}}</span>
            </div>
             <div class="contens_header_span">
                <span>今日兑换数:</span>
                <span class="contens_header_span_number">{{integralT.length || 0}}</span>
            </div>
             <div class="contens_header_span">
                <span>总兑换记录:</span>
                <span class="contens_header_span_number">{{integralTodaySum}}</span>
            </div>
        </div>

        <!-- 在线物品 -->
        <div class="zx">
            <div class="zx_list">
                <div>在线优惠券列表</div>
                <div>
                        <el-table
                        :data="integralquanData"
                        style="width: 100%"
                        max-height="250">
                        <el-table-column
                        fixed
                        prop="_id"
                        label="id"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="integral"
                        label="所需兑换积分"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="sum"
                        label="券面金额/元"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="state"
                        label="代金券状态"
                       >
                       <template slot-scope="scope">
                           {{scope.row.state==true?'在线':'下架'}}
                       </template>
                        </el-table-column>
                         <el-table-column
                        prop="title"
                        label="代金券名称"
                       >
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="120">
                        <template slot-scope="scope">
                            <el-button
                            @click="deleteRow(scope)"
                            type="text"
                            size="small">
                            删除
                            </el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>

                
                <div class="btn_create">
                    <el-button type="primary" @click="createWU">创建兑换物品</el-button>
                </div>
            </div>
            
        </div>

            <!-- 积分兑换列表 -->
        <div class="createQuan">
            <div class="zx_list">
                <div>用户积分详情</div>
                <div>
                     <el-table
                        :data="integralData"
                        style="width: 100%"
                        max-height="300"
                        v-loading="loading"
                         element-loading-text="网速有点慢，请求数据中..."
                          element-loading-spinner="el-icon-loading"
                       
                        >
                        <el-table-column
                        fixed
                        prop="_id"
                        label="id"
                        >
                        </el-table-column>
                         <el-table-column
                        prop="userid"
                        label="身份证号"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="用户姓名"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="number"
                        label="积分"
                       >
                        </el-table-column>

                    </el-table>
                </div>
            </div>
            <div class="pagin">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total=integralNumbers
                    :page-size=100
                    @current-change=currentEvent>
                </el-pagination>
            </div>
        </div>

        <!-- 积分兑换列表 -->
        <div class="createQuan">
            <div class="zx_list">
                <div>兑换详情</div>
                <div>
                     <el-table
                        :data="integralToday"
                        style="width: 100%"
                        max-height="300">
                        <el-table-column
                        fixed
                        prop="_id"
                        label="id"
                        >
                        </el-table-column>
                         <el-table-column
                        prop="userid"
                        label="身份证号"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="date"
                        label="兑换日期"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="detail"
                        label="兑换类型"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="title"
                        label="兑换名称"
                       >
                        </el-table-column>
                         <el-table-column
                        prop="record"
                        label="消耗积分"
                       >
                        </el-table-column>
                        <el-table-column
                        prop="sum"
                        label="券面金额/元"
                       >
                        </el-table-column>
                      
                    </el-table>
                </div>
            </div>
        </div>

        <!-- 创建商品券弹窗 -->
        <div class="tc_box" v-if="isCreate">
            <div class="tc_box_tens">
                <div class="colse">
                    <span @click="CloseTc">关闭</span>
                </div>

                <div class="froms">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="券名称">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="券面金额">
                            <el-input v-model="form.sum"></el-input>
                        </el-form-item>
                        <el-form-item label="有效日期">
                            <el-col :span="11">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="所需积分">
                            <el-input v-model="form.integral"></el-input>
                        </el-form-item>
                        <el-form-item label="使用条件">
                            <el-input v-model="form.condition"></el-input>
                        </el-form-item>
                        <el-form-item label="是否上架">
                            <el-switch
                                v-model="form.value1"
                                active-text="上架"
                                inactive-text="下架"
                                @change='switchEvent'
                                >
                            </el-switch>
                        </el-form-item>
                       
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit" v-loading="loadingCreate" element-loading-spinner="el-icon-loading" element-loading-text="创建中">立即创建</el-button>
                            <el-button @click="CloseTc">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

    
    </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
    name:'integrals',
    data(){
        return{
            integralData:[], 
            integralNumbers:0,
            integralquanData:[],
            integralquanNum:0,
            integralToday:[], 
            integralTodaySum:0,
            integralT:[],
            isCreate:false,
            loading:false,

            form: {
                title: '',
                sum: 0 ,
                date1: '',
                integral:0,
                condition:0,
                value1:true
            },
            loadingCreate:false
        }
    },
    methods:{
     

    //获取到积分用户数
        getIntegralNum(){
             this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                `db.collection("integral").where({
                }).limit(1000).get()`,
            }).then(res=>{
                this.loading = false
                 res.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    });

                    this.integralData = res.data.data
                    this.integralNumbers = res.data.pager.Total
            })
        },

        //获取到积分兑换的物品数量
        getIntegralquan(){
            this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:`db.collection("integral_shop").where({
                }).limit(1000).get()`,
            }).then(re=>{
                 re.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    });

                    this.integralquanData = re.data.data
                    this.integralquanNum =  re.data.pager.Total
                
            })
        },

        //获取今日兑换的数据
        getIntegralToday(){
             this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:`db.collection("integral_record").where({
                }).limit(100).get()`,
            }).then(r=>{

                 r.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    })
                    this.integralToday = r.data.data
                    this.integralTodaySum = r.data.pager.Total

                  let aa =  r.data.data.filter(item=>{
                      return dayjs(item.date).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')
                    })
                    this.integralT = aa
                
            })
        },

        //删除优惠券
        deleteRow(event){
            
            
                    this.$confirm('确定删除这个优惠券吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    // 删除操作
                     this.axios
                    .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query:`db.collection("integral_shop").doc("${event.row._id}").remove()`,
                    }).then(()=>{
                         this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.$router.go(0);
                    })
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
                });
        },

        //创建兑换物品
        createWU(){
            this.isCreate = !this.isCreate
        },
        
        //点击分页
        currentEvent(event){
            this.loading = true
            let a = event - 1;
            let num = a * 100

            //请求数据
              this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:`db.collection("integral").where({
                }).limit(100).skip(${num}).get()`,
            }).then(rs=>{
                 rs.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    })
                        this.loading = false
                    this.integralData = rs.data.data

            })
        },

        //关闭弹窗
        CloseTc(){
            this.isCreate = false,
            this.form.title = '',
            this.form.sum = 0,
            this.form.date1 = '',
            this.form.integral = 0,
            this.form.condition = 0
        },

        //创建类型事件
        switchEvent(event){
            this.form.value1 = event
        },

        //提交创建
        onSubmit(){
            if(this.form.title!=="" && this.form.sum !== 0 && this.form.date1 !=='' && this.form.integral !==0 && this.form.condition !==0){
                this.loadingCreate = true
                  this.axios
            .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:`db.collection("integral_shop").add({
                  data:{
                      condition:${this.form.condition},
                      enddate:'${this.form.date1}',
                      integral:${this.form.integral},
                      state:${this.form.value1},
                      sum:${this.form.sum},
                      title:'${this.form.title}',
                  }
              })`,
            }).then(re=>{
                this.loadingCreate = false
                if(re.data.errcode == 0){
                     this.$notify({
                    title: '创建成功',
                    message: '积分兑换券创建成功',
                    type: 'success'
                    });
                    setTimeout(()=>{
                      this.$router.go(0);  
                    },2000)
                    
                }else{
                     this.$notify.error({
                    title: '创建错误',
                    message: '请刷新页面再试'
                    });
                }
            })
            }else{
                this.$message.error('请把信息填写完整在提交');
            }
        }



        
    },
    created(){
        // this.getTokens()
        this.getTokens()

        //获取当前登录的用户数据
        this.getUserToken()


    },
    mounted(){
        
        setTimeout(()=>{
           this.getIntegralNum()
           this.getIntegralquan()
           this.getIntegralToday()
        },800)
    }

}
</script>
<style scoped>
.contens{

    width: 100%;
    max-height:100%;
    
}
    .contens_header{
        width: 100%;
        height: 150px;
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }
    .contens_header_span{
        display: flex;
        flex-direction: column;
    }
    .contens_header_span_number{
        font-size: 25px;
        font-weight: bolder;
        color: #547ff7;

    }
    .zx{
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        margin: 20px auto;
    }
    .zx_list{
        width: 90%;
        margin: 0 auto;
        z-index: 10;
    }
    .createQuan{
        width: 100%;
        height: 400px;
        background-color: #ffffff;
        margin: 20px auto;
    }
    .btn_create{
        /* position: relative;
        bottom: 0px;
        left: 0px;
        float: right; */
        margin: 10px 0;
        display: flex;
        flex-direction: row;
        justify-content: end;
    }
    .pagin{
        position: relative;
        bottom: -20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .tc_box{
        width: 100%;
        height: 115%;
        background-color: #494949bb;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1000;
    }
    .tc_box_tens{
        width: 50%;
        height: 500px;
         box-shadow: 0 0 9px 0 #0000008e;
         background-color: #ffffff;
             border-radius: 12px;
        position: relative;
        top: 15%;
        left: 25%;
        z-index: 2000;
    }
    .colse{
        float: right;
        padding: 10px 10px;
    }
    .froms{
       width: 80%;
        padding: 40px 0;
    }
</style>